<template>
  <div class="qr-cd-guide-wrapper">
    【仮QRコード発行管理手順】
    <div>
      ➀仮QRコードを発行するため、「発行単位」「QRコード発行件数」を入力し新規登録ボタンを押下します。（仮QRコードが発行されて、発行された行が追加されます）
    </div>
    <div>
      ②情報記入用CSVデータ欄の「取得」ボタンを押下します。（発行された仮QRコードの一覧がCSVでダウンロードされます。）
    </div>
    <div>
      ③「入力用フォームダウンロード」ボタンから一時集合場所等で住民に記載して頂く帳票「仮QRコード台帳」を印刷するEXCELシートをダウンロードします。
    </div>
    <div class="sub-guide">
      ④EXCELシートにはCSV読込ボタンがあり、②で出力したCSVファイルを取り込みます。
    </div>
    <div class="sub-guide">
      ⑤EXCELシートから仮QRコード台帳を印刷します。この時点では、№（発行単位で出力された通番）のみが入力された帳票となります。
    </div>
    <div>
      ⑥QRコード表示欄の「表示」ボタンを押下すると、登録された仮QRコードを全てPDFで出力します。PDFの機能で仮QRコードを印刷します。
    </div>
    <div class="sub-guide">
      ⑦一時集合場所等で、⑤で印刷された「仮QRコード台帳」に住民情報を記載してもらい、⑥で印刷した仮QRコードを住民に配布します。
    </div>
    <div class="sub-guide">
      ⑧⑦で仮QRコード台帳に記載された情報を、⑤のEXCELシート（入力用フォーム）に入力し、CSV出力ボタンからアップロード用データをCSV出力します。
    </div>
    <div>
      ⑨「アップロード」ボタンを押下し、⑧で作成したCSVファイルをサーバにアップロードします。（住民情報を登録します）
    </div>
    <div class="sub-guide mt-4">
      すでに登録した発行単位の名称は使用できません。<br />
      日付を入力するなどして、一意な名称にしてください。<br />
      記入例：２０２１年０７月２０日ｘｘｘ
    </div>
  </div>
</template>

<script>
export default {
  name: "TemporaryQrCodeGuide"
};
</script>
